window.Tributacao = Backbone.Model.extend({

});